module.exports = __webpack_public_path__ + "img/progress_050.b36cbc75.png";